import { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import NiceModal from "@ebay/nice-modal-react";
import ModalManager from "@ebay/nice-modal-react";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import CriteriaCategoryModal from "../CriteriaCategoryModal/CriteriaCategoryModal";
import criteriaAdminService from "../../services/criteriaAdminService";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import "./CriteriaCategoryTable.css";

function CriteriaCategoryTable() {
    const toast = useToastDispatchContext();
    const { getCategories, deleteCategory } = criteriaAdminService;
    const [rows, setRows] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            const [response, error] = await getCategories();
            if (error || !response) {
                toast.error("Error", "Unable to load categories");
                return;
            }
            setRows(response);
        };
        fetchCategories();
    }, []);

    const onClickAdd = () =>
        NiceModal.show(CriteriaCategoryModal, { title: "Create a new category" })
            .then((category) => setRows((prev) => [category, ...prev]));

    const onClickUpdate = (row) =>
        NiceModal.show(CriteriaCategoryModal, { title: "Edit category", data: row })
            .then((category) => setRows((prev) => prev.map((r) => (r.id === category.id ? category : r))));

    const onClickDelete = (row) =>
        ModalManager.show(ApiModal, {
            title: "Delete category " + row.name,
            body: "Do you really want to delete category " + row.name + "? Criteria using it will keep no category.",
            api: { request: deleteCategory, param: [row.id] },
            buttons: [
                { className: "validate", label: "Cancel", style: { marginRight: "20px" } },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
        }).then((res) => {
            if (res?.error != null) {
                toast.error("Error", res.error);
                return;
            }
            setRows((prev) => prev.filter((r) => r.id !== row.id));
        });

    const columnDefs = [
        { headerName: "Name", field: "name", flex: 1, sortable: true },
        {
            headerName: "Actions",
            width: 100,
            pinned: "right",
            cellRenderer: (params) => (
                <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                    <i className="fas fa-edit action-button blue" onClick={() => onClickUpdate(params.data)} />
                    <i className="fas fa-trash action-button red" onClick={() => onClickDelete(params.data)} />
                </div>
            ),
        },
    ];

    return (
        <div className="criteria-admin-grid-section">
            <div className="criteria-category-toolbar">
                <IconButton
                    className="main-iconButton profil_action criteria-admin-add-button"
                    icon="fas fa-plus"
                    onClick={onClickAdd}
                    title="Add category"
                />
            </div>
            <div className="ag-theme-alpine criteria-admin-grid" style={{ width: "100%", height: "400px" }}>
                <AgGridReact
                    enableCellTextSelection={true}
                    rowData={rows}
                    rowHeight={56}
                    columnDefs={columnDefs}
                    defaultColDef={{ sortable: true, filter: true, resizable: true }}
                    pagination={true}
                    paginationPageSize={50}
                />
            </div>
        </div>
    );
}

export default CriteriaCategoryTable;
